<template>
  <div id="app">
    <transition mode="out-in" name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {}
    },
    beforeDestroy() {
      console.log('页面销毁');
      sessionStorage.removeItem('TOKEN');
      sessionStorage.removeItem('ACCOUNT');
    }
  }
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
  #app {
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>

<style scoped>
.vue-form {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/App.vue